export default __webpack_public_path__ + "static/media/fireman.808a2b70.png";